// extracted by mini-css-extract-plugin
export default {"sidebar":"PullRequestFileTree-module__sidebar--Oj679"};